import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

/**
 * Combine class names conditionally (clsx) and resolve Tailwind conflicts so a
 * consumer-supplied `className` reliably wins over a primitive's own default
 * for the same utility group (tailwind-merge).
 *
 * COM-280: this helper is internal to the DesignSystem primitives. The
 * `@design-system` barrel deliberately does not re-export it, so the public
 * runtime namespace stays exactly the nine components.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
